module.exports = __webpack_public_path__ + "img/union-pay.fadc0b4c.png";